<template>
  <div class="status">
    <img :src="icon">
    <div class="title">{{ result.title }}</div>
    <div class="desc">{{ result.desc }}</div>
  </div>
</template>

<script>
import FailureIcon from '../images/icon_signout_failure@2x.png'
import SuccessIcon from '../images/icon_signout_success@2x.png'
export default {
  name: 'signout-result-status',
  props: {
    result: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    icon () {
      switch (this.result.status) {
        case 'SUCCESS':
          return SuccessIcon
        case 'FAILURE':
          return FailureIcon
        default:
          return FailureIcon
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.status {
  text-align: center;
  width: 100%;
  img {
    width: 162px;
    height: 158px;
    margin-top: 141px;
  }
  .title {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 50px;
    margin-top: 22px;
  }
  .desc {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
    margin-top: 20px;
    margin-bottom: 80px;
  }
}
</style>